import Modal, {ModalFuncProps} from 'antd/lib/modal';

export function deleteConfirmation(
	callback: () => void,
	title?: string,
	getContainer?: (instance?: React.ReactInstance) => HTMLElement,
	options?: ModalFuncProps
) {
	Modal.confirm({
		...options,
		title: title || 'This item will be permanently deleted and cannot be recovered. Are you sure?',
		content: '',
		okText: 'Yes',
		okType: 'danger',
		cancelText: 'Cancel',
		onOk() {
			callback();
		},
		getContainer
	});
}